import { render, staticRenderFns } from "./BrickCircle.vue?vue&type=template&id=644962ba&scoped=true&"
import script from "./BrickCircle.vue?vue&type=script&lang=js&"
export * from "./BrickCircle.vue?vue&type=script&lang=js&"
import style0 from "./BrickCircle.vue?vue&type=style&index=0&id=644962ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644962ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644962ba')) {
      api.createRecord('644962ba', component.options)
    } else {
      api.reload('644962ba', component.options)
    }
    module.hot.accept("./BrickCircle.vue?vue&type=template&id=644962ba&scoped=true&", function () {
      api.rerender('644962ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/BrickCircle.vue"
export default component.exports